import { RadioGroup } from "@icg360/design-system";

import { MultiStepFormLayout } from "components/multi-step-form-layout";
import {
  ABOVE_GROUND_POOL_STEP_COUNT,
  IN_GROUND_POOL_STEP_COUNT,
} from "consts";
import { useMultiStepFormState } from "hooks/use-multi-step-form-state";

import {
  PropertyUpdatePoolContext,
  type PropertyUpdatePoolContextState,
} from ".";
import styles from "./property-update-pool.module.scss";

export const PoolFilled = () => {
  const { formNavigate, state, setFields } =
    useMultiStepFormState<PropertyUpdatePoolContextState>(
      PropertyUpdatePoolContext
    );

  const totalSteps =
    state?.poolType === "In-ground"
      ? IN_GROUND_POOL_STEP_COUNT
      : ABOVE_GROUND_POOL_STEP_COUNT;

  return (
    <MultiStepFormLayout
      step={totalSteps - 2}
      totalSteps={totalSteps}
      heading="Is your pool filled?"
      buttonProps={{
        primary: {
          disabled: !state?.filled,
          path: "../decking",
          text: "Next",
        },
        cancel: { path: "/my/property" },
        formNavigate,
      }}
    >
      <RadioGroup
        aria-label="Pool fence options"
        className={styles.radioGroupDS}
        defaultValue={state?.filled}
        onChange={(value: "Yes" | "No") => setFields({ filled: value })}
      >
        <RadioGroup.Card title="Yes" value="Yes" />
        <RadioGroup.Card title="No" value="No" />
      </RadioGroup>
    </MultiStepFormLayout>
  );
};
